import * as navAnim from '../animations/navigation';

let navOpen = false;

const toggleMobileNav = () => {
    const trigger = document.querySelector('.js-hamburger');

    trigger.addEventListener('click', () => {
        trigger.classList.toggle('open');

        if ( !navOpen ) {
            navAnim.openNav();
        } else {
            navAnim.closeNav();
        }

        navOpen = !navOpen;
    });
}

const toggleChildMenu = () => {
    const mobileNav = document.querySelector('.c-nav__items');

    if ( mobileNav ) {        
        // Get all the elements with the class 'js-nav-children-trigger'
        const triggerElements = mobileNav.querySelectorAll('.js-nav-children-trigger a');

        if ( triggerElements ) {
            // Add click event listeners to each trigger element
            triggerElements.forEach(trigger => {
                trigger.addEventListener('click', (event) => {
                    if ( trigger.getAttribute('href') === '#' ) {
                        event.preventDefault(); // Prevent the default behavior of the anchor tag
                        
                        // Toggle the child-menu-open class to the trigger elem
                        trigger.parentElement.classList.toggle('child-menu-open'); 
            
                        // Get the associated sub-menu
                        const subMenu = trigger.nextElementSibling; 
            
                        if (subMenu) {
                            // Toggle the active class to trigger the animation
                            subMenu.classList.toggle('active'); 
                        }
                    }
                });
            });
        }
    }
}

toggleMobileNav();
toggleChildMenu();